import { render, staticRenderFns } from "./FulfillingSquareSpinner.vue?vue&type=template&id=96d5104c&scoped=true"
import script from "./FulfillingSquareSpinner.vue?vue&type=script&lang=js"
export * from "./FulfillingSquareSpinner.vue?vue&type=script&lang=js"
import style0 from "./FulfillingSquareSpinner.vue?vue&type=style&index=0&id=96d5104c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d5104c",
  null
  
)

export default component.exports